import { Component, OnInit, OnDestroy, ChangeDetectorRef, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-thinking-dialog-component',
  imports: [
    MatProgressSpinnerModule,
    MatDialogModule
  ],
  templateUrl: './thinking-dialog-component.html',
  styleUrl: './thinking-dialog-component.scss',
})
export class ThinkingDialogComponent implements OnInit, OnDestroy
{
  private cdr = inject(ChangeDetectorRef);

  thinkingWords = [
    'Processing',
    'Thinking',
    'Analyzing',
    'Computing',
    'Working',
    'Calculating',
    'Crunching'
  ];

  currentWord = this.thinkingWords[0];
  private currentIndex = 0;
  private intervalId?: number;

  ngOnInit(): void
  {
    this.intervalId = window.setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.thinkingWords.length;
      this.currentWord = this.thinkingWords[this.currentIndex];
      this.cdr.detectChanges();
    }, 2000);
  }

  ngOnDestroy(): void
  {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
